export { default as Toast } from './Toast.vue';
export { default as ToastAction } from './ToastAction.vue';
export { default as ToastClose } from './ToastClose.vue';
export { default as ToastDescription } from './ToastDescription.vue';
export { default as Toaster } from './Toaster.vue';
export { default as ToastProvider } from './ToastProvider.vue';
export { default as ToastTitle } from './ToastTitle.vue';
export { default as ToastViewport } from './ToastViewport.vue';
export { toast, useToast } from './use-toast';

import { cva } from 'class-variance-authority';
export const toastVariants = cva(
  'group pointer-events-auto relative flex w-full md:w-fit items-center justify-between space-x-3 overflow-hidden rounded-xl border border-black/10 px-3 py-2 shadow-xl backdrop-blur-[60px] transition-all duration-300 data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-bottom-full data-[state=open]:slide-in-from-bottom-full hover:shadow-2xl',
  {
    variants: {
      variant: {
        default: 'bg-black/80 text-white border-white/30 shadow-lg',
        success: 'success group bg-black/80 text-white/90 border-white/30 shadow-lg',
        info: 'info group bg-black/80 text-white/90 border-white/30 shadow-lg',
        warning: 'warning group bg-black/80 text-white/90 border-white/30 shadow-lg',
        destructive: 'destructive group bg-black/80 text-white/90 border-white/30 shadow-lg',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
